<template>
  <div class="forgetMain">
    <div class="sz_forgetPwd">
      <div class="sz_forgetPwd_title">上海市绿色建筑协会会员信息系统</div>
      <div class="sz-tip">
        <img src="../assets/qrcode2.png" />
        <p>扫码关注协会微信公众号</p>
      </div>
      <div class="sz_forgetPwd_box">
        <img src="../assets/user.png" alt />
        <div class="sz_forgetPwd_line"></div>
        <input type="text" id="username" placeholder="请输入用户名" v-model="username"/>
      </div>
      <div class="sz_forgetPwd_box">
        <img src="../assets/phone.png" alt />
        <div class="sz_forgetPwd_line"></div>
        <input type="text" id="phone" placeholder="请输入手机号" v-model="phone"/>
      </div>
      <div class="sz_forgetPwd_box">
        <img src="../assets/verification.png" alt />
        <div class="sz_forgetPwd_line"></div>
        <input type="text" id="verification" placeholder="请输入验证码" v-model="verification"/>
      </div>
      <canvas @click="draw(show_num)" id="canvas" width="90" height="35" style="position: absolute;top: 190px;left: 445px;"></canvas>
      <div class="sz_forgetPwd_box">
        <img src="../assets/password.png" alt />
        <div class="sz_forgetPwd_line"></div>
        <input type="password" placeholder="请输入新密码" id="password" v-model="newPassword"/>
      </div>
      <div class="upload-box">
        <div class="ship-inline">
          <input type="file" hidden ref="selectFile" @change="handleChange"/>
          <el-button size="medium" type="primary" @click="uploadFile" style="margin-right:5px;">上传证件照</el-button>
          <span>
            <span v-if="!fileUrl">{{fileName.length > 10 ? (fileName.slice(0, 10) + '...') : fileName}}</span>
            <a v-if="fileUrl" :href="fileUrl" target="_blank">{{fileName.length > 10 ? (fileName.slice(0, 10) + '...') : fileName}}</a>
          </span>
        </div>
      </div>
      <div class="bottom_btns">
        <span @click="toLogin">返回登录</span>
      </div>
      <div class="sz_forgetPwd_bottom next" @click="next">下一步</div>
    </div>
  </div>
</template>

<script>
import util from '../utils/util'
import * as API from '../utils/apiService'
import * as Cache from '../utils/cache'

export default {
  data () {
    return {
      show_num: [],
      fileList: [],
      username: '',
      phone: '',
      verification: '',
      newPassword: '',
      file: {},
      fileUrl: '',
      fileName: ''
    }
  },
  mounted () {
    this.draw(this.show_num)
  },
  methods: {
    uploadFile () {
      this.$refs.selectFile.click()
    },
    // 文件改变时触发
    handleChange (e) {
      this.file = e.target.files[0]
      this.fileName = this.file.name
      this.$refs.selectFile.value = null
      this.fileUrl = this.getFileURL(this.file)
      return e
    },
    // 获取文件路径
    getFileURL (file) {
      let url = null
      if (file) {
        if (window.createObjectURL !== undefined) {
          // basic
          url = window.createObjectURL(file)
        } else if (window.URL !== undefined) {
          // mozilla(firefox)
          url = window.URL.createObjectURL(file)
        } else if (window.webkitURL !== undefined) {
          // webkit or chrome
          url = window.webkitURL.createObjectURL(file)
        }
      }
      return url
    },
    draw: util.draw,
    toLogin () {
      this.$router.push('/login')
    },
    next () {
      if (!this.username) {
        this.$message.error('用户名不能为空')
        return
      }
      if (!this.phone) {
        this.$message.error('手机号不能为空')
        return
      }
      if (!this.verification) {
        this.$message.error('验证码不能为空')
        return
      }
      if (this.verification && this.verification !== this.show_num.join('')) {
        this.$message.error('验证码错误')
        return
      }
      if (!this.newPassword) {
        this.$message.error('新密码不能为空')
        return
      }
      if (!this.file.name) {
        this.$message.error('请上传证件照')
        return
      }
      let password = Cache.getUserInfo().password
      let params = {
        username: this.username,
        contactpersonphone: this.phone,
        password: password,
        file: this.file
      }
      API.forgetPwd(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.$message.success('密码已重置')
          localStorage.setItem('password_worthiest', this.password)
          this.$router.push('/login')
        } else {
          this.$message.error(resp.resultMsg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.forgetMain {
  width: 100%;
  height: 100%;
  background: url(../assets/bg.png) 100% 100% no-repeat;
  overflow: hidden;
  position: relative;
  margin: 0;
  padding: 0;
  text-align: center;
  footer {
    position: fixed;
    width: 100%;
    height: 30px;
    bottom: 0;
    background: linear-gradient(transparent, #326272);
    color: #fff;
    font-size: 14px;
  }
  #KBStatic {
    position: absolute;
    left: 0px;
    top: 0px;
  }
  #btnSendCode {
    float: right;
    width: 80px;
    margin-top: -66px;
    margin-left: -160px;
    color: #007ddb;
    font-size: 14px;
    cursor: pointer;
    z-index: top;
    background-color: white;
    line-height: 26px;
  }
  .sz_forgetPwd {
    width: 572px;
    height: 454px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: rgba(255, 255, 255, 1);
    /*border: 1px solid #979797;
    border-radius: 12px;*/
  }
  .sz_forgetPwd_title {
    background: rgba(255, 255, 255, 1);
    border-radius: 12px 12px 0 0;
    height: 74px;
    font-size: 24px;
    color: #0096cc;
    line-height: 87px;
    font-weight: bold;
  }
  .sz_forgetPwd_img {
    vertical-align: middle;
    width: 139px;
    height: 42px;
  }
  .sz_forgetPwd_box {
    background: #ffffff;
    width: 272px;
    height: 46px;
    margin: 0 268px 10px;
    position: relative;
    border-bottom: 1px solid #737383;
  }
  .sz_forgetPwd_box img {
    float: left;
    margin-top: 16px;
    margin-left: 5px;
    width: 18px;
    height: 20px;
  }
  .sz_forgetPwd_line {
    width: 1px;
    height: 22px;
    background: #979797;
    float: left;
    margin-top: 15px;
    margin-left: 7px;
  }
  .sz_forgetPwd_box input {
    width: 200px;
    height: 24px;
    font-size: 16px;
    color: #333;
    line-height: 24px;
    border: none;
    outline: none;
    margin-top: 12px;
    margin-left: -26px;
  }
  .sz_forgetPwd_bottom {
    background: #0096cc;
    /* border: 1px solid #979797; */
    border-radius: 20px;
    width: 272px;
    height: 37px;
    margin-left: 268px;
    margin-top: 16px;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    line-height: 37px;
    cursor: pointer;
  }
  .sz_forgetPwd_bottom:hover {
    background: #1665c1;
  }
  .sz_small_title {
    color: #a4a4a4;
    font-size: 14px;
    float: right;
    margin-right: 110px;
    border-bottom: 1px solid #a4a4a4;
  }
  .password_remember {
    text-align: left;
    width: 110px;
    margin-left: 49%;
    margin-top: -10px;
    font-size: 12px;
  }
  .remenber_text {
    color: #a4a4a4;
  }
  .bottom_btns {
    width: 110px;
    margin-left: 49%;
    margin-top: 12px;
    text-align: left;
  }
  .bottom_btns span {
    color: #7c7c7c;
    font-size: 15px;
    text-align: left;
    cursor: pointer;
  }
  .bottom_btns:hover span {
    color: #1665c1;
  }
  .sz-tip {
    width: 266px;
    float: left;
    text-align: center;
    margin-top: 30px;
  }
  .sz-tip img {
    width: 230px;
  }
  .sz-tip p {
    font-size: 16px;
    color: #7c7c7c;
    line-height: 18px;
    margin: 0;
  }
  .upload-box {
    width: 272px;
    margin-left: 266px;
    text-align: left;
  }
  .upload-box .ship-inline {
    white-space: nowrap;
    display: inline-block;
    position: relative;
  }
  .upload-box .upload-btn {
    height: 30px;
    background-color: #1e9fff;
    color: #ffffff;
    line-height: 30px;
    text-align: center;
    font-size: 14px;
    outline: none;
    border: 0 none;
  }
  .upload-box .upload-name {
    display: inline-block;
  }
  .upload-box .upload-label {
    height: 30px;
    line-height: 30px;
  }
  .ship-inline input:last-of-type {
    position: absolute;
    left: 0;
    top: 0;
    height: 30px;
    width: 86px;
    opacity: 0;
    cursor: pointer;
    vertical-align: middle;
  }
  .upload-name {
    display: inline-block;
    margin-left: 6px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    color: #777;
  }
}
</style>
